/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { authModalReducer } from './authModal.slice';

export * from './AuthContext';
export * from './AuthModal';
export { authModalActions } from './authModal.slice';

export const authReducers = {
    authModal: authModalReducer,
};
